import { headingColor, headingSm, textMd } from '@insify/design-system/typography';
import { WizardLayoutFormWithCommonSection, removeProspectIdFromStorage } from '@insify/funnel-components';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

export function VersionOutdatedPage(): JSX.Element {
  const { t } = useTranslation(['funnel']);

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>): Promise<void> => {
    e.preventDefault();
    removeProspectIdFromStorage(sessionStorage);
    window.location.href = '/';
  };

  return (
    <WizardLayoutFormWithCommonSection
      isBackHidden={true}
      isSubmitting={false}
      forwardCopy={t('funnel:version_outdated_continue')}
      onSubmit={onSubmit}
    >
      <h1 className={clsx(headingColor, headingSm)}>{t('funnel:version_outdated_title')}</h1>
      <p className={textMd} style={{ color: 'var(--dark-80)', marginTop: 2 }}>
        {t('funnel:version_outdated_description')}
      </p>
    </WizardLayoutFormWithCommonSection>
  );
}
